$(document).ready(function(){
$('.product__accordion details').on('click', function () {
  // Close other open details
  $('.product__accordion details').not(this).removeAttr('open');
});
$('.media-main--featured').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    fade: false,
    asNavFor: '.media-thumbs',
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        dots: true
      }
    }
      ]
});
$('.media-thumbs').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical:true,
    asNavFor: '.media-main--featured',
    dots: false,
    infinite: false,
    focusOnSelect: true,
    verticalSwiping:true,
    responsive: [
    {
      breakpoint: 820,
      settings: {
        slidesToShow: 3,
      }
    }
      ]
});

  
  $('.featured-collection').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        dots: false,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        dots: false,
        arrows: false,
        slidesToShow: 1.2,
        slidesToScroll: 1
      }
    }
    ]
  });

  
  function recommendationslider() {
  $('.relatedPro .product-grid').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        dots: false,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        dots: false,
        arrows: false,
        slidesToShow: 1.2,
        slidesToScroll: 1
      }
    }
    ]
  });
  }
  recommendationslider()
  setTimeout(function(){
    recommendationslider();
  },3000)
  recommendationslider()
  setTimeout(function(){
    recommendationslider();
  },5000) 

  $('.eventsslider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3.5,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        dots: false,
        arrows: false,
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        dots: false,
        arrows: false,
        slidesToShow: 1.3,
        slidesToScroll: 1
      }
    }
  ]
  });

  $('.categorygallery').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3.7,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        dots: false,
        arrows: false,
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        dots: false,
        arrows: false,
        slidesToShow: 1.3,
        slidesToScroll: 1
      }
    }
    ]
  });

  $('.tribestoriesslider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        dots: false,
        arrows: false,
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        dots: false,
        arrows: false,
        slidesToShow: 1.3,
        slidesToScroll: 1
      }
    }
  ]
  });


});